import Vue from 'vue'
import {
  Image,
  Cascader,
  Checkbox,
  CheckboxButton,
  CheckboxGroup,
  Row,
  Col,
  Pagination,
  Dialog,
  Dropdown,
  DropdownMenu,
  DropdownItem,
  Input,
  InputNumber,
  Button,
  Form,
  FormItem,
  Carousel,
  CarouselItem,
  Loading,
  Message,
  Breadcrumb,
  BreadcrumbItem,
  Scrollbar,
  Menu,
  MenuItemGroup,
  Submenu,
  MenuItem,
  Notification,
  Tabs,
  TabPane,
  Steps,
  Step,
  Table,
  TableColumn,
  Card,
  DatePicker,
  Select,
  Option,
  OptionGroup,
  Upload,
  Tree,
  Transfer,
  Popconfirm,
  Popover,
  MessageBox,
  Radio,
  RadioGroup,
  RadioButton,
  Timeline,
  TimelineItem,
  Progress,
  Switch,
  Container,
  Divider,
  tooltip,
  avatar,
} from 'element-ui'
import '@/styles/element-variables.scss'
const components = {
  Image,
  Cascader,
  Checkbox,
  CheckboxButton,
  CheckboxGroup,
  Row,
  Col,
  Pagination,
  Dialog,
  Dropdown,
  DropdownMenu,
  DropdownItem,
  Input,
  InputNumber,
  Button,
  Form,
  FormItem,
  Carousel,
  CarouselItem,
  Loading,
  Breadcrumb,
  BreadcrumbItem,
  Scrollbar,
  Menu,
  MenuItemGroup,
  Submenu,
  MenuItem,
  Tabs,
  TabPane,
  Steps,
  Step,
  Table,
  TableColumn,
  Card,
  DatePicker,
  Select,
  Option,
  OptionGroup,
  Upload,
  Tree,
  Transfer,
  Popconfirm,
  Popover,
  Radio,
  RadioGroup,
  RadioButton,
  Timeline,
  TimelineItem,
  Progress,
  Switch,
  Container,
  Divider,
  tooltip,
  avatar,
}
Vue.prototype.$message = Message
Vue.prototype.$notify = Notification
Vue.prototype.$confirm = MessageBox.confirm

Object.values(components).forEach(component => {
  Vue.use(component)
})
